module.exports = __webpack_public_path__ + "images/Cursor.6803ed242e1f375f8e1bf6c517944312.svg";